import React, { useState } from 'react';
import Modal from '../../../components/Modal/index';
import '../../../../sass/pages/account/boost_modal.scss';
import trackEvent from '../../../helpers/gtm/eventPush';

const BoostModal = () => {
  const [showDialog, updateShowDialog] = useState(false);

  const close = () => {
    updateShowDialog(false);
  };

  const open = () => {
    trackEvent({
      category: 'upgrade',
      action: 'upgrade_form_advert_boosts_info',
      label: `${window._sr.page.loginReturnPath}`,
    });
    updateShowDialog(true);
  };

  const modalLabelTextBoost = (
    <span>
      <i className="far fa-rocket boost-box__icon"></i> New! Boost your ad
    </span>
  );

  return (
    <>
      {showDialog ? (
        <Modal
          close={close}
          showDialog={showDialog}
          modalLabelText={modalLabelTextBoost}
          id="boost-modal"
          initialFocus=".modal__close"
        >
          <div className="boost-modal">
            <div className="boost-modal__copy">
              <p className="boost-modal__text">
                Send your Ad to the top of the listings with monthly Boosts!
              </p>
              <p className="boost-modal__text">
                Available with our PRO packages. Look for the{' '}
                <i className="far fa-rocket product-selector__boost-icon"></i>
              </p>
            </div>
            <div className="boost-modal__image">
              <img
                className="image-boost"
                alt=""
                src="/img/spareroom/modals/boost.png?v=1"
              />
            </div>
          </div>
        </Modal>
      ) : null}
      <button
        onClick={open}
        className="button button--link"
        type="button"
        aria-label="more info about boosts"
      >
        <i className="far fa-info-circle" />
      </button>
    </>
  );
};

export default BoostModal;
